// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"3d1c3a47","368":"e935db20","447":"32610ebb","455":"2c49538a","587":"d9579e43","625":"593aedf3","629":"580588d2","719":"0ecfc91f","873":"576473a6","937":"35333af0","977":"8d96ae19"}[chunkId] + ".chunk.js";
};